// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"00de9647","323":"d0f2019d","709":"b3cfef67","763":"16b4c43a"}[chunkId] + ".chunk.js";
};